import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  cartProductCount,
  getCartProducts,
} from "../../../redux/reduxApi/website/CartProductCount";
import { Plus, Trash2 } from "lucide-react";
import {
  clearCartApi,
  deleteFromCartApi,
  updateCartProductApi,
} from "../../../redux/api/website/Addtocartapi";
import { AddToCart } from "./utilsfuncart";
import {
  decrementGuestCartCount,
  resetGuestCartCount,
} from "../../../redux/reduxSlice/website/CartSlice";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import Shoploader from "../loader/Shoploader";
import { FaMinus } from "@react-icons/all-files/fa/FaMinus";
import { FaPlus } from "@react-icons/all-files/fa/FaPlus";

function mapCartRows(cartRows) {
  if (!Array.isArray(cartRows) || cartRows.length === 0) return [];
  return cartRows.map((item) => ({
    ...item,
    part_key: item.part_key || item.partKey || item.ROWID,
    part_type: item.part_type || item.partType || "N/A",
    part_no: item.part_no || item.partNo || "",
    image: item.image || "",
    price: Number(item.price) || 0,
    quantity: Number(item.quantity) || 1,
    totalPrice: Number(item.totalPrice) || 0,
  }));
}

function getProductImage(product) {
  return (
    product?.image ||
    product?.images?.image?.[0]?.id ||
    product?.images?.image?.id ||
    "/placeholder.png"
  );
}

const Cart = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const cart = useSelector((state) => state.Cart.CartProducts?.cart || []);
  console.log("cart data from redux ", cart);
  const [cartData, setCartData] = useState([]);
  const [guestProducts, setGuestProducts] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [loading, setLoading] = useState(false);
  const userId = localStorage.getItem("customerId");

  let guestId = Cookies.get("guest_id");
  useEffect(() => {
    const fetchGuestCart = async () => {
      try {
        setLoading(true);
        const resp = await dispatch(getCartProducts());

        const cartRows = resp?.payload?.data?.cart;
        if (Array.isArray(cartRows) && cartRows.length > 0) {
          const productsArray = mapCartRows(cartRows);
          setCartData(productsArray);
        } else {
          setCartData([]);
        }
      } catch (error) {
        console.error("Error fetching guest cart:", error);
        setCartData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchGuestCart();
  }, [dispatch, userId, guestId]);

  useEffect(() => {
    console.log("cart data from after show me part ", cartData);
    const initialQuantities = {};
    cartData?.forEach((product) => {
      initialQuantities[product.part_key] = product.quantity || 1;
    });
    setQuantities(initialQuantities);
  }, [cartData]);

  const increaseQuantity = async (productId) => {
    setQuantities((prev) => ({
      ...prev,
      [productId]: (prev[productId] || 1) + 1,
    }));

    // try {
    //   const res = await dispatch(updateCartProductApi({ customerId: userId, productId: productId, action: "increment" }));
    //   console.log("res q", res);
    // } catch (error) {
    //   console.log("error in q", error);
    // }
  };

  const decreaseQuantity = async (productId) => {
    setQuantities((prev) => ({
      ...prev,
      [productId]: Math.max(1, (prev[productId] || 1) - 1),
    }));

    // try {
    //   const res = await dispatch(updateCartProductApi({ customerId: userId, productId: productId, action: "decrement" }));
    //   console.log("res q", res);
    // } catch (error) {
    //   console.log("error in q", error);
    // }
  };

  // const handleRemoveProduct = async (uniqueSerialNo) => {
  //   try {
  //     if (userId) {
  //       const data = {
  //         uniqueSerialNo: uniqueSerialNo,
  //         customerId: userId,
  //       };
  //       const res = await dispatch(deleteFromCartApi(data));
  //       console.log("response from delete cart product ", res);
  //       if (res?.payload?.data?.success) {
  //         toast.success("Product removed from cart successfully!");
  //         const updatedCart = cartData.filter(
  //           (item) => item.uniqueSerialNo !== uniqueSerialNo
  //         ); // 👈 Remove locally
  //         setCartData(updatedCart); // 👈 Force update immediately
  //         dispatch(getCartProducts());
  //         dispatch(cartProductCount());
  //       }
  //     } else {
  //       const data = {
  //         uniqueSerialNo: uniqueSerialNo,
  //         // customerId: userId,
  //         guestId: guestId,
  //       };
  //       const res = await dispatch(deleteFromCartApi(data));
  //       console.log("response from delete cart product ", res);
  //       if (res?.payload?.data?.success) {
  //         toast.success("Product removed from cart successfully!");
  //         const updatedCart = cartData.filter(
  //           (item) => item.uniqueSerialNo !== uniqueSerialNo
  //         ); // 👈 Remove locally
  //         setCartData(updatedCart); // 👈 Force update immediately
  //         dispatch(getCartProducts());
  //         dispatch(cartProductCount());
  //       }
  //     }
  //   } catch (error) {
  //     console.log("Error deleting from cart: ", error);
  //   }
  // };

  const handleRemoveProduct = async (uniqueSerialNo) => {
    try {
      const payload = userId
        ? { uniqueSerialNo, customerId: userId }
        : { uniqueSerialNo, guestId };

      const response = await dispatch(deleteFromCartApi(payload));
   
      if (response?.payload?.data?.success) {
        toast.success("Product removed from cart successfully!");

        const cartResponse = await dispatch(getCartProducts());
        const updatedCartItems = cartResponse?.payload?.data?.cart || [];
        const enrichedItems = mapCartRows(updatedCartItems);
        setCartData(enrichedItems);
        dispatch(cartProductCount(userId));
      }
    } catch (error) {
      console.error("Error removing product from cart:", error);
      toast.error("Failed to remove product. Please try again.");
    }
  };

  const clearCart = async () => {
    try {
      if (userId) {
        setCartData([]);
        await dispatch(clearCartApi());
        await dispatch(getCartProducts());
        await dispatch(cartProductCount(userId));
      } else {
        localStorage.removeItem("guestCart");
        setGuestProducts([]);
        setCartData([]); // 👈 Force update immediately
        dispatch(resetGuestCartCount());
      }
    } catch (error) {
      console.log("Error clearing cart: ", error);
    }
  };

  const shippingRate = 0.18;

  const subtotal = cartData
    .reduce((acc, product) => {
      const qty = quantities[product.part_key] || 1;
      const price = product.price || product.sellingPrice || 0;
      return acc + price * qty;
    }, 0)
    .toFixed(2);
  const shippingCost = (parseFloat(subtotal) * shippingRate).toFixed(2);
  const total = (parseFloat(subtotal) + parseFloat(shippingCost)).toFixed(2);

  const handleCheckout = () => {
    const userId = localStorage.getItem("customerId");

    const cartWithQuantities = cartData.map((product) => ({
      ...product,
      quantity: quantities[product.part_key] || 1,
    }));

    if (userId) {
      navigate("/shop/checkouts", {
        state: {
          cartItems: cartWithQuantities,
          subtotal,
          shippingCost,
          total,
        },
      });
    } else {
      navigate("/login");
      localStorage.setItem("redirect", location.pathname);
    }
  };

  useEffect(() => {
    const datastore = async () => {
      if (userId && guestId) {
        try {
          for (const item of cartData.length > 0) {
            const quantity = quantities[item.part_key] || item.quantity || 1;
            const reponse = await AddToCart({
              guestId: guestId,
              uniqueSerialNo: item.uniqueKey,
              customerId: userId,
              part_key: item.part_key,
              quantity: quantity || "1",
              price: item.price,
            });
          
            console.log("resssss",reponse)
          }

          dispatch(cartProductCount(userId));
          dispatch(getCartProducts(userId));
          Cookies.remove("guest_id");
        } catch (error) {
          console.error("Error adding guest products to cart:", error);
        }
      }
    };
    datastore();
  }, [guestProducts, userId]);

  return (
    <div className="">
      {loading ? ( // Show loader when loading
        <div className="relative w-full h-[300px]">
          <Shoploader />
        </div>
      ) : (
        <div className="mx-auto pt-5 flex flex-col md:flex-row lg:mt-20 lg:gap-6 md:gap-2 lg:w-10/12 md:w-[87%] w-11/12">
          {/* Product Section */}
          <div className="flex-1 p-6 rounded-xl shadow-md  border border-gray-200 d-none d-sm-block mb-4">
            <p className="lg:text-5xl font-bold text-blue-900 dark:text-black-700 md:text-4xl text-center pb-3">
              Cart
            </p>
            {cartData?.length > 0 ? (
              <table className="w-full p-2 text-left">
                <thead>
                  <tr className=" text-base border-b pb-1 ">
                    <th className="w-25 ml-4">Product</th>
                    <th className="">Price</th>
                    <th className="">Quantity</th>
                    <th className="pr-3">Subtotal</th>
                    <th className="">Action</th>
                  </tr>
                </thead>
                <tbody className=" ">
                  {cartData.map((product) => (
                    <tr
                      className="border-b  border-gray-300 "
                      style={{ borderRadius: "10px" }}
                      key={product.part_key}
                    >
                      <td className="py-3 pr-3 ">
                        <img
                          src={getProductImage(product)}
                          alt={product.name}
                          className="lg:min-w-[10vw] min-w-[14vw] lg:h-28 h-24 my-auto border p-2 mt-1 rounded object-contain"
                        />
                        <p className="font-[500] text-sm mb-0">
                          {product.name}
                        </p>
                      </td>
                      <td className="font-semibold  pb-5 px-1 ">
                        $
                        {(product.price || product.sellingPrice || 0).toFixed(
                          2
                        )}
                      </td>
                      <td className="pb-5 ">
                        <span className="border rounded-md p-2">
                          <button
                            onClick={() => decreaseQuantity(product.part_key)}
                            className="p-1"
                          >
                            <FaMinus size="12px" />
                          </button>
                          <input
                            type="number"
                            value={quantities[product.part_key]}
                            min="1"
                            onChange={(e) =>
                              setQuantities({
                                ...quantities,
                                [product.part_key]: Math.max(
                                  "",
                                  parseInt(e.target.value)
                                ),
                              })
                            }
                            className="lg:w-14 w-10  py-[6px] text-center border-none outline-none text-base font-bold"
                          />
                          <button
                            onClick={() => increaseQuantity(product.part_key)}
                            className="p-1"
                          >
                            <FaPlus size="12px" />
                          </button>
                        </span>
                      </td>
                      <td className="font-semibold pb-5 px-1 ml-3">
                        $
                        {(
                          (product.price || product.sellingPrice || 0) *
                          quantities[product.part_key]
                        ).toFixed(2)}
                      </td>
                      <td className="pb-5 px-1">
                        {/* <button
                          onClick={() =>
                            handleRemoveProduct(product.uniqueSerialNo)
                          }
                          className="text-white px-3 rounded font-bold"
                        > */}
                        <button
                          onClick={() => {
                            console.log("Deleteing Product-->", product); // Logs the full product object
                            handleRemoveProduct(product.uniqueSerialNo);
                          }}
                          className="text-white px-3 rounded font-bold"
                        >
                          <Trash2 color="#F97316" size="16px" strokeWidth="1" />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="text-center text-gray-500">
                <p className="text-xl">You have no products in your cart.</p>
                <Link to="/shop">
                  <button className="bg-orange-500 text-white px-6 py-2 rounded mt-3">
                    Continue Shopping
                  </button>
                </Link>
              </div>
            )}
            {cartData?.length > 0 && (
              <div className="flex  flex-end">
                {/* <button className="bg-[#034C8C] text-white px-6 py-2 rounded-full mt-3">
                  Update Cart
                </button> */}
                <button
                  className="bg-orange-500 text-white px-6 py-2 rounded-full mt-3"
                  onClick={clearCart}
                >
                  Clear Cart
                </button>
              </div>
            )}
          </div>
          {/* cart for mobile view start */}
          {cartData?.length > 0 ? (
            <div className="flex-1 p-2 gap-2 rounded-lg border mb-3 border-gray-200 d-block d-sm-none ">
              {cartData.map((product) => (
                <div
                  className="flex items-center   p-2 rounded-lg border-b border-gray-200 "
                  key={product.ROWID}
                >
                  <div style={{ width: "200px" }} className="w-200px">
                    <img
                      src={getProductImage(product)}
                      alt={product.name}
                      className="h-28 w-[120px] object-contain"
                    />
                  </div>
                  <div className="py-2 px-3 w-10/12 ">
                    <div className="text-xl py-1 font-bold">
                      {product.part_type}
                    </div>
                    <div className="py-1 font-bold">
                      ${(product.price || product.sellingPrice || 0).toFixed(2)}
                    </div>
                    <span className="border rounded-md p-2">
                      <button
                        onClick={() => decreaseQuantity(product.part_key)}
                        className="p-1"
                      >
                        <FaMinus size="12px" />
                      </button>
                      <input
                        type="number"
                        value={quantities[product.part_key]}
                        min="1"
                        onChange={(e) =>
                          setQuantities({
                            ...quantities,
                            [product.part_key]: Math.max(
                              "",
                              parseInt(e.target.value)
                            ),
                          })
                        }
                        className="w-14  py-[6px] text-center border-none outline-none text-base font-bold"
                      />
                      <button
                        onClick={() => increaseQuantity(product.part_key)}
                        className="p-1"
                      >
                        <FaPlus size="12px" />
                      </button>
                    </span>
                    <div className="my-2 flex ">
                      <button
                        onClick={() =>
                          handleRemoveProduct(product.uniqueSerialNo)
                        }
                        className="text-white rounded font-bold"
                      >
                        <Trash2 color="#F97316" size="25px" strokeWidth="1" />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center lg:hidden md:hidden sm:block text-gray-500 p-5 mb-5 rounded-lg border border-gray-200">
              <p className="text-xl">You have no products in your cart.</p>
              <Link to="/shop">
                <button className="bg-orange-500 text-white px-6 py-2 rounded mt-3">
                  Continue Shopping
                </button>
              </Link>
            </div>
          )}
          {/* cart for mobile view end */}

          {/* Summary Section */}
          {cartData?.length > 0 && (
            <div className="w-full h-100  md:w-1/3 px-6 lg:py-8 md:py-4 py-9  rounded-xl shadow-md border border-gray-200 mb-4">
              <p className="lg:text-5xl font-bold text-blue-900 dark:text-black-700 md:text-4xl text-center pb-3">
                Summary
              </p>
              <div className="flex justify-between text-lg mb-2">
                <p>Subtotal:</p>
                <p className="font-semibold">${subtotal}</p>
              </div>
              <hr />
              {/* <div className="flex justify-between text-lg mb-2">
                <p>
                  Shipping Charges:
                  <br />
                  <span className="text-sm">Estimated Delivery: 3-5 business days</span>
                </p>
                <p className="font-bold">${shippingCost}</p>
              </div>
              <hr /> */}
              <div className="flex justify-between text-lg mb-2">
                <p>Total:</p>
                {/* <p className="font-semibold">${total}</p> */}
                <p className="font-semibold">${subtotal}</p>
              </div>
              <div className=" w-full flex flex-col gap-2">
                <button
                  onClick={handleCheckout}
                  className=" bg-orange-500 py-2 px-3 text-white  rounded-full "
                >
                  Proceed to Checkout
                </button>
                <Link to="/shop">
                  <button className="w-full  bg-[#034C8C] py-2 px-3 text-white  rounded-full">
                    Continue Shopping
                  </button>
                </Link>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Cart;
